module.exports = __webpack_public_path__ + "static/img/page_bg.b3ca1b8d.png";